import BaseComponent from 'components/pages/EditMonthlyTotalAsset';
import {
  getMonthlyTotalAsset,
  pacthMonthlyTotalAsset,
} from 'domains/api/monthly_total_assets';
import { resetCurrentUser } from 'domains/current_user';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router';
import { MonthlyTotalAsset } from 'types';

const EditMonthlyTotalAsset: React.FC = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  const monthlyTotalAssetId = id ? parseInt(id, 10) : -1;

  const [monthlyTotalAsset, setMonthlyTotalAsset] =
    useState<MonthlyTotalAsset | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    setIsLoading(true);
    void getMonthlyTotalAsset(monthlyTotalAssetId)
      .then((response) => {
        setMonthlyTotalAsset(response.monthly_total_asset);
        setIsLoading(false);
      })
      .catch(() => {
        resetCurrentUser();
        navigate('/signIn');
      });
  }, [monthlyTotalAssetId, navigate]);

  const onUpdate = (newMonthlyTotalAsset: MonthlyTotalAsset) => {
    setIsLoading(true);
    void pacthMonthlyTotalAsset(newMonthlyTotalAsset)
      .then((_) => {
        navigate('/monthly_total_assets');
      })
      .catch(() => {
        resetCurrentUser();
        navigate('/signIn');
      });
  };

  return (
    <BaseComponent
      isLoading={isLoading}
      monthlyTotalAsset={monthlyTotalAsset}
      onUpdate={onUpdate}
    />
  );
};

export default EditMonthlyTotalAsset;
